import type { PrequalScenario } from './types/prescreen'

const LABELS: Record<PrequalScenario, string> = {
  borrower: 'Primary borrower',
  co_borrower: 'Co-borrower',
  joint_borrower_lead: 'Joint — borrower lead',
  joint_co_borrower_lead: 'Joint — co-borrower lead'
}

export function prequalScenarioLabel(scenario: PrequalScenario | undefined): string | undefined {
  if (!scenario) {
    return undefined
  }
  return LABELS[scenario]
}
